export default {
	props:{
		id: String,
		name: String,
		value: {type:[String, Number]},
		trueValue: {type:[String, Number], default:'1'},
		falseValue: {type:[String, Number], default:''},
		autocomplete: String,
		label: String,
		clearable: {type:Boolean, default:false},
		disabled: {type:Boolean, default:false},
		errorMsg: String,
	},
	data(){
		return {
			hintVisible: true,
			uniqueId: null,
			isChecked: false,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(val){
				this.isChecked = val===this.trueValue;
			},
		},
		isChecked:{
			handler(val){
				const eventValue = val?this.trueValue:this.falseValue
				this.$emit('input', eventValue);
				this.$emit('change', eventValue);
			},
		},
	},
	computed:{
		hasValue(){
			return !!this.isChecked;
		},
		mainCssClass(){
			return ['custom-chbox', this.clearable?'clearable':'', this.hasValue?'has-value':''];
		},
		elementId(){
			if(this.id) return this.id;
			if(this.name) return this.name.replaceAll('[','.').replaceAll(']','')+'.'+this.trueValue;
			if(this.uniqueId) return this.uniqueId+'.'+this.trueValue;
			return '';
		}
	},
	methods: {
		onClear(){
			this.isChecked = false;
			this.$emit('clear');
		},
		onChange(ev){
			this.isChecked = ev.target.checked;
		}
	},
	mounted() {
		this.uniqueId = this._uid?'id-'+this._uid:'';
	},
	template: `
<label :class="mainCssClass">
  <input type="checkbox" :id="elementId" :name="name" :value="trueValue" :checked="isChecked" @change="onChange" :autocomplete="autocomplete" />
  <span class="lbl-holder" v-t="label"></span>
  <span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
  <span v-if="clearable && hasValue" class="clear-btn" @click="onClear"></span>
</label>
`,
}
